import React from 'react';
import { PlusIcon } from '@heroicons/react/24/outline';
import { useContent } from '../ContentContext';
import { getIconComponent } from '../utils/iconMap';

const defaultAmenityIcons = [
  'HomeIcon',
  'ShieldCheckIcon',
  'BoltIcon',
  'FaceSmileIcon',
  'VideoCameraIcon',
  'SunIcon'
];

const amenitiesData = [
  { img: '/images/grandentrance.jpeg' },
  { img: '/images/DTCPApproved.jpeg' },
  { img: '/images/ModernStreetLights.jpeg' },
  { img: '/images/childrenPlayArea.jpeg' },
  { img: '/images/24_7Security.jpeg' },
  { img: '/images/LandScapedParks.jpeg' }
];

const Amenities = () => {
  const { content } = useContent();
  const amenities = content.amenities;
  return (
    <section id="amenities" className="py-12 sm:py-24 px-4 sm:px-10 bg-gray-50">
      <div className="container mx-auto flex flex-col lg:flex-row justify-between items-center mb-10 sm:mb-20 text-center lg:text-left gap-6">
        <div>
          <span className="text-[#EF5D22] font-bold tracking-widest uppercase text-xs sm:text-sm mb-3 sm:mb-4 block">{amenities.badge}</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 leading-tight">
            {amenities.titlePart1} <span className="text-[#EF5D22]">{amenities.titlePart2}</span>
          </h2>
        </div>
        <div className="max-w-md">
          <p className="text-gray-600 text-base sm:text-lg">
            {amenities.description}
          </p>
        </div>
      </div>
      <div className="container mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-10">
        {amenities.items.map((item: any, idx: number) => {
          const IconComponent = getIconComponent(item.icon || defaultAmenityIcons[idx]);
          return (
            <div key={idx} className="bg-white rounded-2xl sm:rounded-[2rem] overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-500 group border border-gray-100">
              <div className="relative h-48 sm:h-72 overflow-hidden">
                <img src={amenitiesData[idx]?.img || '/images/hero.jpeg'} alt={item.title} className="w-full h-full object-cover group-hover:scale-110 transition duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end p-4 sm:p-8">
                  <p className="text-white text-xs sm:text-sm font-medium">{item.hoverText || item.hover_text}</p>
                </div>
                <div className="absolute top-4 sm:top-6 left-4 sm:left-6 w-10 h-10 sm:w-12 sm:h-12 bg-white/90 backdrop-blur-sm rounded-xl flex items-center justify-center text-[#EF5D22] shadow-lg">
                  <IconComponent className="w-5 h-5 sm:w-6 sm:h-6" />
                </div>
              </div>
              <div className="p-4 sm:p-8 flex justify-between items-center">
                <h4 className="font-extrabold text-lg sm:text-xl text-gray-900 group-hover:text-[#EF5D22] transition-colors">{item.title}</h4>
                <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full border border-gray-100 flex items-center justify-center group-hover:bg-[#EF5D22] group-hover:text-white transition-all duration-300">
                  <PlusIcon className="w-4 h-4 sm:w-5 sm:h-5" />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Amenities;
